export default class DBHandler{
    
    HOST =  'https://retencionesmedicos.escobar.gob.ar/'//'http://127.0.0.1:1900/'//

    enviarPeticion(fun,url,metodo,datos,asinc=true,auth=false){
        var request = new XMLHttpRequest();
        request.onreadystatechange = function(){
        if(this.readyState === 4 && this.status === 200){
            if (fun != null){
            if (this.responseText.length > 0){
                let val = JSON.parse(this.responseText)
                fun(val);
            }
            else{
                fun();
            }
            }
        }
        };
        request.open(metodo, this.HOST  +url ,asinc);
        //if(auth){
        //    request.setRequestHeader('id',document.cookie.split(';')[0].split('=')[1]);
        //}
        if (metodo === "POST"){
            request.setRequestHeader('Content-type','application/json');
            request.send(JSON.stringify(datos));
        }
        else {request.send();}
    }
}